export default __webpack_public_path__ + "static/media/failure-illus.5fe3a17d.svg";